"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_cookie_1 = require("react-cookie");
var react_redux_1 = require("react-redux");
var semantic_ui_react_1 = require("semantic-ui-react");
var he_1 = __importDefault(require("he"));
var moment_1 = __importDefault(require("moment"));
var react_helmet_1 = __importDefault(require("react-helmet"));
//import { Twitter, Facebook, Whatsapp, Telegram, Linkedin, Reddit, Mail } from 'react-share-social';
var api = __importStar(require("../user-review/userReviewActions"));
var actions = __importStar(require("./postActions"));
var feedActions = __importStar(require("../util/feed/feedActions"));
var FollowingActions_1 = require("../yourtrybe/following/FollowingActions");
var trybeIcon = '/img/loop-subtract.svg';
var interval;
var Post = /** @class */ (function (_super) {
    __extends(Post, _super);
    function Post(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, getPostInfo, location, info, pathname, pathSort, id, pathname, pathSort, id, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, getPostInfo = _a.getPostInfo, location = _a.location, info = _a.info;
                        if (!!info.id) return [3 /*break*/, 2];
                        pathname = location.pathname;
                        pathSort = pathname.split("/");
                        id = pathSort[2];
                        console.log(id);
                        return [4 /*yield*/, getPostInfo({ id: id })];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        pathname = location.pathname;
                        pathSort = pathname.split("/");
                        id = pathSort[2];
                        _b = id;
                        if (!_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, getPostInfo({ id: id })];
                    case 3:
                        _b = (_c.sent());
                        _c.label = 4;
                    case 4:
                        _b;
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.onScroll = function (_a) {
            var target = _a.target;
            console.log(window.innerHeight);
        };
        _this.tipAmountChange = function (value) { return _this.setState({ tipAmount: value }); };
        _this.handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, userInfo, followUser, unfollowUser, info, following, amIFollowing, cookies, token, authorName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, userInfo = _a.userInfo, followUser = _a.followUser, unfollowUser = _a.unfollowUser, info = _a.info, following = _a.following, amIFollowing = _a.amIFollowing, cookies = _a.cookies;
                        token = cookies.get('trybe_jwt', { path: '/' });
                        authorName = info._embedded.author[0].name;
                        if (!!following) return [3 /*break*/, 3];
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'follow-btn',
                            'event_category': 'community',
                            'event_action': 'follow-btn',
                            'event_label': authorName //the article’s author
                        });
                        return [4 /*yield*/, followUser({ userId: userInfo.id, targetId: info.author, token: token, authorName: authorName })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, amIFollowing({ userId: userInfo.id, id: info.author })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.defaultClickHandler = function (postInfo) { return __awaiter(_this, void 0, void 0, function () {
            var _a, history, clearPostInfo, getPostInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, history = _a.history, clearPostInfo = _a.clearPostInfo, getPostInfo = _a.getPostInfo;
                        return [4 /*yield*/, history.push("/".concat(postInfo.slug))];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, clearPostInfo()];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, getPostInfo({ id: "/".concat(postInfo.slug) })];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handlePaginationChange = function (e, _a) {
            var activePage = _a.activePage;
            _this.setState({ activePage: activePage });
        };
        _this.showModal = function () {
            _this.setState({ show: true });
        };
        _this.hideModal = function () {
            var dismissReport = _this.props.dismissReport;
            _this.setState({ show: false });
            dismissReport();
        };
        _this.handleConfirm = function () {
            _this.setState({ result: 'confirmed', open: false });
        };
        _this.handleCancel = function () {
            _this.setState({ result: 'cancelled', open: false });
        };
        _this.highlightTextTrigger = function (highlight) {
            setTimeout(function () {
                document.querySelectorAll('.cz-set-selection-text').forEach(function (a) {
                    a.remove();
                });
                var elements = document.getElementsByClassName("highlight");
                while (elements.length > 0) {
                    elements[0].classList.remove('highlight');
                }
                var sel, range, node;
                if (window.getSelection) {
                    sel = window.getSelection();
                    if (sel.getRangeAt && sel.rangeCount) {
                        range = window.getSelection().getRangeAt(0);
                        var docFragment = range.cloneContents();
                        if (docFragment.querySelectorAll('p, ul, ol, li, h1, h2, h3, h4, h5, h6').length > 0)
                            return;
                        _this.setState({ windowTextSelection: window.getSelection().toString() });
                        if (sel.toString().trim() !== '') {
                            var html = '';
                            if (highlight) {
                                html = '<span class="highlightComment">' + _this.highlightShare() + range + '</span>';
                            }
                            else {
                                html = '<span class="highlight">' + _this.highlightShare() + range + '</span>';
                            }
                            range.deleteContents();
                            var el = document.createElement("span");
                            el.innerHTML = html;
                            var frag = document.createDocumentFragment(), node, lastNode;
                            while ((node = el.firstChild)) {
                                node.style.backgroundColor = 'red !important';
                                lastNode = frag.appendChild(node);
                            }
                            range.insertNode(frag);
                            setTimeout(function () {
                                _this.clickEvents();
                            }, 200);
                        }
                    }
                }
                else if (document.selection && document.selection.createRange) {
                    range = document.selection.createRange();
                    range.collapse(false);
                    range.pasteHTML(html);
                }
                _this.clickEvents();
            }, 200);
        };
        _this.highlightTextTriggerr = function (highlight) {
            var range = window.getSelection().getRangeAt(0);
            var docFragment = range.cloneContents();
            if (docFragment.querySelector('p'))
                return;
            var span = document.createElement('span');
            span.className = 'highlightComment';
            range.surroundContents(span);
        };
        _this.highlightBrush = function () {
            _this.highlightTextTrigger(true);
        };
        _this.commentBrush = function () {
            _this.setState({ highlightText: _this.state.windowTextSelection });
            _this.executeScroll();
        };
        _this.highlightShare = function () {
            var windowTextSelection = _this.state.windowTextSelection;
            return ("<span class=\"cz-set-selection-text\">\n        <span class=\"spanul\">\n          <span class=\"spanli\">\n            <a id=\"highlightBrush\"><img src=\"/img/brush-share-icon.png\" alt=\"brush-share-icon.png\" /></a>\n          </span>\n          <span class=\"spanli\">\n            <a id=\"commentBrush\"><img src=\"/img/comment-share-icon.png\" alt=\"comment-share-icon.png\" /></a>\n          </span>\n          <span class=\"spanli\">\n            <a href=\"https://twitter.com/intent/tweet?text=".concat(windowTextSelection, "\" target=\"_blank\"><img src=\"/img/twitter-share-icon.png\" alt=\"twitter-share-icon.png\" /></a>\n          </span>\n        </span>\n      </span>"));
        };
        _this.executeScroll = function () {
            _this.addCommentRef && _this.addCommentRef.current && _this.addCommentRef.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        };
        _this.handleChange = function (e, _a) {
            var value = _a.value;
            return _this.setState({ report_reason: value });
        };
        _this.defaultClickHandler = _this.defaultClickHandler.bind(_this);
        _this.handleConfirm = _this.handleConfirm.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleCuratePost = _this.handleCuratePost.bind(_this);
        _this.state = {
            activePage: 1,
            tipAmount: 500,
            tipHidden: true,
            show: false,
            open: false,
            openVoteConfirm: false,
            reportedCommentId: [],
            reportCommentJson: {
                commentId: null,
                reportCommentMessage: null,
            },
            startTime: null,
            saveReadTime: false,
            ratingTimer: 30,
            windowTextSelection: '',
            highlightText: '',
            report_reason: '',
            ratingModalShow: false
        };
        _this.addCommentRef = react_1.default.createRef();
        return _this;
    }
    Post.prototype.componentDidMount = function () {
        var _this = this;
        var ratingTimer = this.state.ratingTimer;
        interval = setInterval(function () {
            _this.setState({ ratingTimer: --ratingTimer });
        }, 1000);
        this.fetchData();
        document.querySelector('.app-body').scrollTop = 0;
        var el = document.querySelector('.cz-single-article-container');
        el.addEventListener('scroll', this.onScroll);
    };
    Post.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clearPostInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clearPostInfo = this.props.clearPostInfo;
                        return [4 /*yield*/, clearPostInfo()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Post.prototype.reportComment = function (_a) {
        var commentId = _a.commentId;
        return __awaiter(this, void 0, void 0, function () {
            var _b, sendReportComment, cookies, info, userInfo, token;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this.props, sendReportComment = _b.sendReportComment, cookies = _b.cookies, info = _b.info, userInfo = _b.userInfo;
                        token = cookies.get('trybe_jwt', { path: '/' });
                        return [4 /*yield*/, sendReportComment({ token: token, post: info.id, commentId: commentId, userId: userInfo.id, target: info.slug, articleName: info.title.rendered })];
                    case 1:
                        _c.sent();
                        this.setState({
                            open: false,
                            reportCommentJson: {
                                commentId: null,
                                reportCommentMessage: null
                            },
                            reportedCommentId: __spreadArray(__spreadArray([], this.state.reportedCommentId, true), [commentId], false),
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Post.prototype.upVoteComment = function (_a) {
        var commentId = _a.commentId, comment_user_id = _a.comment_user_id;
        return __awaiter(this, void 0, void 0, function () {
            var _b, sendUpVoteComment, cookies, info, userInfo, token;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this.props, sendUpVoteComment = _b.sendUpVoteComment, cookies = _b.cookies, info = _b.info, userInfo = _b.userInfo;
                        token = cookies.get('trybe_jwt', { path: '/' });
                        return [4 /*yield*/, sendUpVoteComment({ token: token, post: info.id, commentId: commentId, userId: userInfo.id, target: info.slug, comment_user_id: comment_user_id, articleName: info.title.rendered })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Post.prototype.reportSpamComment = function (_a) {
        var commentId = _a.commentId, commentUserId = _a.commentUserId;
        return __awaiter(this, void 0, void 0, function () {
            var _b, sendReportSpamComment, cookies, info, userInfo, getPostComments, activePage, token;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this.props, sendReportSpamComment = _b.sendReportSpamComment, cookies = _b.cookies, info = _b.info, userInfo = _b.userInfo, getPostComments = _b.getPostComments;
                        activePage = this.state.activePage;
                        token = cookies.get('trybe_jwt', { path: '/' });
                        return [4 /*yield*/, sendReportSpamComment({ token: token, post: info.id, commentId: commentId, userId: userInfo.id, target: info.slug, commentUserId: commentUserId, articleName: info.title.rendered })];
                    case 1:
                        _c.sent();
                        if (!!info) return [3 /*break*/, 2];
                        history.push('/404');
                        return [3 /*break*/, 4];
                    case 2:
                        if (!info.author) return [3 /*break*/, 4];
                        return [4 /*yield*/, getPostComments({ post: info.id, page: activePage, token: token })];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Post.prototype.renderTokens = function (centered) {
        var postRating = this.props.postRating;
        var style = {
            justifyContent: centered ? 'center' : 'flex-end',
            margin: centered ? '0 auto' : 0,
            marginTop: '10px'
        };
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "tokens", style: style }, { children: [centered ? "".concat(postRating.tokens ? postRating.tokens : 0) : postRating.tokens, (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: trybeIcon })] })));
    };
    Post.prototype.handlePaginationUp = function () {
        var activePage = this.state.activePage;
        this.setState({ activePage: activePage + 1 });
    };
    Post.prototype.handlePaginationDown = function () {
        var activePage = this.state.activePage;
        this.setState({ activePage: activePage - 1 });
    };
    Post.prototype.clickEvents = function () {
        if (document.getElementById("commentBrush")) {
            document.getElementById("commentBrush").addEventListener("click", this.commentBrush);
        }
        if (document.getElementById("highlightBrush")) {
            document.getElementById("highlightBrush").addEventListener("click", this.highlightBrush);
        }
    };
    Post.prototype.handleCuratePost = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, cookies, info, setCurate, userInfo, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, cookies = _a.cookies, info = _a.info, setCurate = _a.setCurate, userInfo = _a.userInfo;
                        token = cookies.get('trybe_jwt', { path: '/' });
                        return [4 /*yield*/, setCurate({ token: token, post: info.id, authorId: info.author, userId: userInfo.id, target: info.slug, articleName: info.title.rendered })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Post.prototype.render = function () {
        var _this = this;
        var _a = this.props, info = _a.info, userInfo = _a.userInfo, history = _a.history, isPostLoading = _a.isPostLoading, cookies = _a.cookies;
        if (!info) {
            history.push('/404');
            return (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { active: true });
        }
        var id = info.id, title = info.title, _embedded = info._embedded, content = info.content, date_gmt = info.date_gmt, author = info.author, role = info.role, read_time = info.read_time, role = info.role, acf = info.acf;
        return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, __assign({ className: "post-container cz-single-article" }, { children: [id && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Container, __assign({ className: "cz-back-article" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "cz-grid-center" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, __assign({ className: "backarticle", onClick: function () { return history.push('/blog/'); } }, { children: "Back to blog" })) })) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "cz-single-article-container", style: { marginBottom: "150px" } }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: id ? ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { children: [(0, jsx_runtime_1.jsxs)(react_helmet_1.default, { children: [(0, jsx_runtime_1.jsx)("title", { children: title ? 'Loop Finance: ' + he_1.default.decode(title.rendered) : 'Loop Finance' }), (0, jsx_runtime_1.jsx)("meta", { httpEquiv: "ScreenOrientation", content: "autoRotate:disabled" }), role == 'subscriber' && ((0, jsx_runtime_1.jsx)("meta", { name: "robots", content: "noindex" })), (0, jsx_runtime_1.jsx)("meta", { name: "title", content: he_1.default.decode(title.rendered).replace(/(<([^>]+)>)/ig, '') }), (0, jsx_runtime_1.jsx)("meta", { name: "description", content: (info.excerpt.rendered).replace(/(<([^>]+)>)/ig, '') }), (0, jsx_runtime_1.jsx)("meta", { property: "og:site_name", content: "Loop" }), (0, jsx_runtime_1.jsx)("meta", { property: "og:url", content: 'https://loop.markets/' + info.slug }), (0, jsx_runtime_1.jsx)("meta", { property: "og:type", content: "article" }), (0, jsx_runtime_1.jsx)("meta", { property: "og:title", content: he_1.default.decode(title.rendered).replace(/(<([^>]+)>)/ig, '') }), (0, jsx_runtime_1.jsx)("meta", { property: "og:description", content: (info.excerpt.rendered).replace(/(<([^>]+)>)/ig, '') }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image", content: _embedded['wp:featuredmedia'] && _embedded['wp:featuredmedia'][0].source_url }), (0, jsx_runtime_1.jsx)("meta", { property: "og:updated_time", content: info.modified }), (0, jsx_runtime_1.jsx)("meta", { property: "article:published_time", content: info.date }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:card", content: "summary_large_image" }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:site", content: "https://loop.markets/".concat(info.slug) }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:title", content: he_1.default.decode(title.rendered).replace(/(<([^>]+)>)/ig, '') }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:description", content: (info.excerpt.rendered).replace(/(<([^>]+)>)/ig, '') }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:image", content: _embedded['wp:featuredmedia'] && _embedded['wp:featuredmedia'][0].source_url }), (0, jsx_runtime_1.jsx)("script", { id: "ze-snippet", src: "https://static.zdassets.com/ekr/snippet.js?key=6c0c34a0-c54f-4cfa-94d8-480e9d57cc24" }), (0, jsx_runtime_1.jsx)("script", { children: " window.prerenderReady = true " }), (acf === null || acf === void 0 ? void 0 : acf.canonical_link) && (0, jsx_runtime_1.jsx)("link", { rel: "canonical", href: acf === null || acf === void 0 ? void 0 : acf.canonical_link })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, __assign({ className: "sub-header cz-post-header-top" }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Column, __assign({ width: "16" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "post-header" }, { children: (0, jsx_runtime_1.jsx)("h1", { children: he_1.default.decode(title.rendered) }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "post-date" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "post-bar" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "post-author" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Row, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, __assign({ width: 10 }, { children: (0, jsx_runtime_1.jsxs)("b", __assign({ style: { marginRight: '6px', color: '#4DD4B6' } }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: _embedded.author[0].avatar_urls[96], avatar: true, circular: true, as: react_router_dom_1.Link, to: "/user/".concat(_embedded.author[0].id, "/") }), (0, jsx_runtime_1.jsxs)("span", { children: ["Published By: ", _embedded.author[0].name] })] })) })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, __assign({ width: 6, className: "post_date_detail_colum" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "post_date_details" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "lightShade" }, { children: moment_1.default
                                                                                                .utc(date_gmt)
                                                                                                .local()
                                                                                                .format('MMMM DD, YYYY') })), (0, jsx_runtime_1.jsx)("img", { style: { marginLeft: '25px', marginRight: '5px' }, src: "/img/icon-readtime.svg", alt: "" }), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "lightShade" }, { children: [read_time, " Min"] })), userInfo.id === author && (' | ')] })) }))] }) }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "post-author cz-post-mobile-only" }, { children: [(0, jsx_runtime_1.jsxs)("b", __assign({ style: { marginRight: '25px', color: '#4DD4B6' } }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: _embedded.author[0].avatar_urls[96], avatar: true, circular: true }), (0, jsx_runtime_1.jsxs)("p", { children: ["Published By: ", _embedded.author[0].name] })] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "lightShade" }, { children: moment_1.default
                                                                            .utc(date_gmt)
                                                                            .local()
                                                                            .format('MMMM DD, YYYY') })), (0, jsx_runtime_1.jsx)("img", { style: { marginLeft: '25px', marginRight: '5px' }, src: "/img/icon-readtime.svg", alt: "" }), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "lightShade" }, { children: [read_time, " Min"] })), userInfo.id === author && (' | ')] }))] })) }))] })) })), _embedded['wp:featuredmedia'] && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, __assign({ className: "cz-post-header-top" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "post-featured-image" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: "".concat(_embedded['wp:featuredmedia'][0].source_url) }) })) }) }))), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, __assign({ className: "cz-set-set" }, { children: (0, jsx_runtime_1.jsx)("div", { className: "post", onMouseUp: function () { return _this.highlightTextTrigger(false); }, dangerouslySetInnerHTML: { __html: content === null || content === void 0 ? void 0 : content.rendered } }) }))] })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { active: isPostLoading })) }) }) }))] })));
    };
    return Post;
}(react_1.PureComponent));
exports.default = (0, react_cookie_1.withCookies)((0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state, ownProps) {
    return {
        cookies: ownProps.cookies,
        userInfo: state.user.userInfo,
        postRating: state.post.postRating,
        ratingLoading: state.post.ratingLoading,
        isAuthorized: state.user.userIsLogged,
        comments: state.post.postComments,
        commentPages: state.post.commentPages,
        isCommentsLoading: state.post.commentsLoading,
        isPostLoading: state.post.postLoading,
        moreArticlesLoading: state.post.moreArticlesLoading,
        info: state.post.postInfo,
        articlesInfo: state.post.moreArticles,
        ratingSending: state.post.ratingSending,
        following: state.userReview.amIFollowing,
        isLoadingSubscription: state.following.loadingSubscribe,
        gettingUserReviewData: state.userReview.loading,
        subscriptionSuccessfull: state.following.subscriptionSuccessfull,
        reportMessage: state.post.reportMessage,
        isAdmin: state.user.userInfo.extra_capabilities,
        userRole: state.user.userInfo.roles,
        curateLoading: state.post.curateLoading,
        ratings: state.feed.ratings,
        ratingsLoading: state.feed.ratingsLoading
    };
}, function (dispatch) { return ({
    getPostInfo: function (params) {
        dispatch(actions.getPostInfo(params));
    },
    resetCommentSuccess: function () {
        dispatch(actions.resetCommentSuccess());
    },
    reportArticle: function (params) {
        dispatch(actions.reportArticleRoutine(params));
    },
    dismissReport: function () {
        dispatch(actions.dismissReportRoutine());
    },
    getAuthorPost: function (params) {
        dispatch(actions.getAuthorPost(params));
    },
    getPostComments: function (params) {
        dispatch(actions.getPostComments(params));
    },
    sendPostRating: function (params) {
        dispatch(actions.sendPostRating(params));
    },
    clearPostInfo: function () {
        dispatch(actions.clearPostInfo());
    },
    sendReply: function (params) {
        dispatch(actions.replyToPostComment(params));
    },
    sendUpdateComment: function (params) {
        dispatch(actions.updateToPostComment(params));
    },
    sendReportComment: function (params) {
        dispatch(actions.reportToPostComment(params));
    },
    sendUpVoteComment: function (params) {
        dispatch(actions.upVoteToPostComment(params));
    },
    sendReportSpamComment: function (params) {
        dispatch(actions.reportSpamComment(params));
    },
    getRating: function (params) {
        dispatch(actions.getPostRating(params));
    },
    ratePost: function (params) {
        dispatch(actions.ratePost(params));
    },
    amIFollowing: function (params) {
        dispatch(api.amIFollowing(params));
    },
    followUser: function (params) {
        dispatch((0, FollowingActions_1.follow)(params));
    },
    unfollowUser: function (params) {
        dispatch((0, FollowingActions_1.unfollow)(params));
    },
    clearPosts: function () {
        dispatch(feedActions.clearPostsRoutine());
    },
    setPost: function (postInfo) {
        dispatch(actions.setPostInfo(postInfo));
    },
    setCurate: function (params) {
        dispatch(actions.setCuratePost(params));
    },
    getRatings: function (postId) {
        dispatch(feedActions.getRatingsRoutine(postId));
    },
}); })(Post)));
